

import API_URL from "../api/url";
import api from "../api/api";



export const createService = async (uid) => {
    try {
        const response = await api.get(API_URL.refreshToken, {
            headers: { uuid: uid },
            config: { showMessage: true },
          });
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  export const generateSessionToken = async (csrftoken) => {
    try {
        const response = await api.post(API_URL.sessionToken,{}, {
            headers: { token: csrftoken },
            config: { showMessage: true },
          });
      return response.data;
    } catch (error) {
      throw error;
    }
  };




